<div style="position:relative; z-index: 100; width: 100%;">
<nav class="navbar navbar-expand-md pt-0 " style="position: fixed; width: 100%;">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['']"><img class="lozad" src="assets/img/rev00.png"> </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse ms-md-4" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" [routerLink]="['']">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/about']">About Us</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/network']">Network</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/digital']">Digital Tribe</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</div>
<!----end navbar--->

<!---HERO SECTION---->
<section class="about-banner hero  position-relative overflow-hidden">
    <div class="overlay">
      <div class="content">
        <h1 data-aos="fade-up">Revolution 00</h1>
        <h2 data-aos="fade-up">Two Brothers. One Purpose. A Community Reborn.</h2>
        <p data-aos="fade-up" class="highlight text-center">A Movement. A Platform. A Future for People of Color.</p>
        <p data-aos="fade-up" class="">
          <strong>Phoenix, Arizona</strong> — In a world where technology too often divides us and politics continues to fail the communities most in need, two brothers are rewriting the story — not just for themselves, but for every Black and Brown person who has ever felt unheard, unseen, or left behind.
        </p>
        <p data-aos="fade-up">
          Born from necessity and driven by purpose, Revolution 00 is more than a platform. It is the heartbeat of a movement. It was born out of a shared pain, a relentless hope, and the unshakable belief that the power to change our reality has always lived within us.
        </p>
        <p data-aos="fade-up">
          Together, these two brothers looked around at their neighborhoods and saw something the world didn’t: potential still burning beneath the ashes of generational struggle.
        </p >
        <blockquote data-aos="fade-up">
          “Nobody’s coming to save us,” says Ken. “But what if we could give our people the tools to save themselves? Not just inspiration — but infrastructure.”
        </blockquote>
        <a href="https://www.revolution00.com" class="btn" data-aos="fade-up">Join the Movement</a>
      </div>
    </div>
    <div class="shad position-absolute"></div>
      <div class="blur">
        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1024 1024"><path fill="#fff" d="M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7" stroke-width="25.5" stroke="#fff"/></svg>
      </div>
  </section>
<!---END HERO SECTION---->

<!---REVOLUTION SECTION---->

<section>
	<div class="resident  pt-5">
		<div class="container">
			<div class="row">
				<div class="col-lg-6">
					<div class="tribe mt-md-5">
						<h3 class="purple"><span class="dark-blue">Brothers by Blood. Warriors by Purpose - From Vision To Reality — Thanks to UMYO</span></h3>
						<p data-aos="fade-up">Founded by <b>Ken Muhammad</b> and his younger brother King David, <b>Revolution 00</b> didn’t begin in a boardroom. It started in living rooms filled with tough conversations, in barbershops where wisdom was passed down, and in community spaces where grief and hope lived side by side.</p>
						<p data-aos="fade-up">The vision became possible when <b>Kenneth Muhammad</b> saw <b>Gregory Barnard’s story</b> in Black Enterprise—a story of a Black father and his three sons building a tech legacy through <b>UMYO, The Wall Street of Technology.</b></p>
						<p data-aos="fade-up">Kenneth reached out. Gregory listened. “Within <b>weeks</b>, not months, Gregory & his sons built exactly what we needed,” says Muhammad. “UMYO handles every tech concern. We don’t have to worry about hiring engineers or paying thousands monthly just to maintain it. They created the infrastructure, and now we <b>share profits as real partners.”</b></p>
					</div>
				</div>
				<div class="col-lg-6">
					<div class="com-back h-100 aos-init aos-animate" data-aos="zoom-in-down">
					<img  class="lozad img-fluid" src="assets/img/brother.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!---END REVOLUTION SECTION---->

<!----POWER SECTION--->
<section>
	<div class="power">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-9">
					<div class="corporation position-relative px-md-4">
						<h2 data-aos="fade-up" class="text-white text-center mb-4">A Mission Powered by Accountability and Ownership</h2>
						<p data-aos="fade-up" class="">For far too long, communities of color have been conditioned to wait. Wait for legislation. Wait for a seat at the table. Wait for justice.</p>
						<p data-aos="fade-up" ><b>Revolution 00</b> rejects that narrative. Instead, it stands on one truth: we are the answer.</p>
						<p data-aos="fade-up" >With Revolution 00, communities can:</p>
						<ul class="ps-3 aos-init" data-aos="fade-up">
							<li class="mb-3"><b>Own their digital presence</b> without fear of exploitation</li>
							<li class="mb-3"><b>Support Black and Brown businesses</b> through real-time commerce and exposure</li>
							<li class="fw-bold mb-3">Report violent crime anonymously while promoting mental wellness</li>
							<li class="mb-3"><b>Employ our youth</b> with tech-driven roles in digital customer support centers</li>
							<li class="mb-3"><b>Circulate wealth</b> that begins and ends with our communities</li>
						</ul>
						<blockquote data-aos="fade-up">
							"We don’t need to beg for power," says Ken’s brother. "We need to build our own infrastructure.<br> One that can’t be gentrified or bought out."
						</blockquote>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!---END POWER SECTION---->


<!---- CARDS SECTION--->
<section class="revolution-section">
  <div class="container">
    <div class="row justify-content-center">
    	<div class="col-md-9">
    		<h2 data-aos="fade-up">This Isn’t an App. It’s a Revolution.</h2>
    <p data-aos="fade-up">
      Unlike social media giants that profit off our culture while silencing our voices, Revolution 00 gives control back to the people — with:
    </p>
    <ul data-aos="fade-up">
      <li class="mb-2">Private digital ecosystems for community organizations and movements</li>
      <li class="mb-2">Secure, ad-free spaces where creativity, accountability, and healing can thrive</li>
      <li class="mb-2">Custom tech maintenance and updates handled by Revolution 00, freeing up leaders to lead</li>
      <li class="mb-2">A revenue-sharing model that keeps money circulating within the culture</li>
    </ul>
    <p class="highlight" data-aos="fade-up">And yes — we give back, because giving is currency.</p>
    <p data-aos="fade-up">
      This is technology as liberation, not surveillance. It’s data as a tool, not a weapon.
    </p>
    <p data-aos="fade-up">
      You don’t need permission to join the movement. You don’t have to be an influencer, an organization, or have thousands of followers.
    </p>
    <p data-aos="fade-up">
      You just have to believe in something bigger than yourself — and believe in us.
    </p>
    <p data-aos="fade-up">
      By visiting <a href="https://www.revolution00.com" target="_blank">Revolution00.com</a>, individuals can connect, build, and collaborate with others ready to create something different — something ours.
    </p>
    <p class="highlight" data-aos="fade-up">This is community reinvestment, done our way with our own rules.</p>
    	</div>
    </div>
  </div>
</section>

<section class="mission-section">
  <div class="container">
    <div class="row justify-content-center">
    	<div class="col-md-9">
    		<h2 data-aos="fade-up">A Mission Powered by Accountability and Ownership</h2>
    <p data-aos="fade-up">
      For far too long, communities of color have been conditioned to wait for legislation, a seat at the table, and justice. Revolution 00 rejects that narrative. Instead, it stands on one truth: we are the answer when united with a cause under one roof — within a Digital Gated Community.
    </p>
    <p data-aos="fade-up">
      Revolution 00 isn’t just about what you can do — it’s about where you can do it.
    </p>
    <p class="highlight" data-aos="fade-up">
      For only $9.99/month, members get access to exclusive, culturally curated versions of the world’s most powerful platforms — tailored for safety, mental wellness, and community growth:
    </p>
    <ul class="features" data-aos="fade-up">
      <li>🛒 Marketplace for buying, selling, and supporting local entrepreneurs</li>
      <li>📽️ Virtual conferencing, webinars, Podcast, Radio and live streaming tools</li>
      <li>🗣️ Tweet-style microblogging for communication without censorship</li>
      <li>🔒 A secure, private ecosystem designed to build community wealth</li>
    </ul>
    <p><strong>Members can:</strong></p>
    <ul class="member-actions" data-aos="fade-up">
      <li>Post Items for Sale</li>
      <li>Offer Services</li>
      <li>Support Local Entrepreneurs</li>
      <li>Foster Growth in Safe Digital Spaces</li>
    </ul>
    <p data-aos="fade-up">
      It’s a clean environment of growth where people of color can speak freely without the chaos and negativity of traditional social media. It’s a digital barbershop for real conversations, collective healing, and vision — without fear.
    </p>
    <p data-aos="fade-up">
      Social media is not free — it comes at a cost. While other platforms may seem "free," they come with hidden costs like mental health struggles, bullying, trauma, and negativity that affect our lives.
    </p>
    <p data-aos="fade-up">
      When you register with Revolution 00, you're joining a community centered on everyone's interests. You're not just contributing to something meaningful — you're investing in your own safety, support, and a space with fewer trolls.
    </p>
    <p class="highlight" data-aos="fade-up">
      Membership at Revolution 00 is about being part of something special and supportive. Just like a gated community — only digital. <strong>Our Rules. Our Way.</strong>
    </p>
    <p data-aos="fade-up">
      Revolution 00 offers a diverse range of platforms with more than <strong>15 Unique Tribes/Hubs</strong>, exclusively for its members.
    </p>
    	</div>
    </div>
  </div>
</section>


<!----END CARDS SECTION--->

<section class="pledge-footer overflow-hidden">
  <div class="container">
    <div class="row justify-content-center">
    	<div class="col-md-9">
    		<h2 data-aos="fade-up">We Take the Pledge. We Protect Our People.</h2>
    <p class="pledge-text" data-aos="fade-up">
      Revolution 00 introduces the <strong>IAM PLEDGE</strong> — a community-first initiative to report violence and uplift mental health. It’s not just about calling out harm; it’s about calling in healing.
    </p>
    <p data-aos="fade-up">
      Every community that joins commits to being the keeper of their neighbor, the voice of reason, and the protector of peace.
    </p>

    <h3 class="join-heading" data-aos="fade-up">JOIN THE MOVEMENT. BUILD THE FUTURE.</h3>
    <p data-aos="fade-up">
      Whether you’re an entrepreneur, activist, artist, student, or parent — <b>Revolution 00</b> is now a home you can be proud to call your own!!
    </p>

    <div class="contact-info">
      <p data-aos="fade-up">🌐 <a href="https://www.revolution00.com" target="_blank">Visit: www.revolution00.com</a></p>
      <p data-aos="fade-up">📧 Email: <a href="mailto:info@revolution00.com">info@revolution00.com</a></p>
      <p data-aos="fade-up">📲 Follow: @Revolution00</p>
    </div>

    <div class="footer-bottom">
      <p data-aos="fade-up"><strong>Revolution 00</strong></p>
      <p data-aos="fade-up">Powered by UMYO. Driven by the People.</p>
      <p data-aos="fade-up">We Stand On Business. Empowering Today. Transforming Tomorrow.</p>
    </div>
    	</div>
    </div>
  </div>
</section>



